import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

const DataLayer = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={(color: string) => {
        return (
          <>
            <path
              d="M14.8837 8.13953V2.90698C14.8837 2.53387 14.7176 2.15731 14.3904 1.86592C14.0606 1.57224 13.5977 1.39535 13.1005 1.39535H3.1786C2.68139 1.39535 2.21844 1.57224 1.88863 1.86592C1.56145 2.15731 1.39535 2.53387 1.39535 2.90698V16.1628C1.39535 16.5359 1.56145 16.9125 1.88863 17.2039C2.21844 17.4975 2.68139 17.6744 3.1786 17.6744H4.4186C4.80392 17.6744 5.11628 17.9868 5.11628 18.3721C5.11628 18.7574 4.80392 19.0698 4.4186 19.0698H3.1786C2.36007 19.0698 1.56081 18.7807 0.960211 18.2458C0.357034 17.7086 0 16.9615 0 16.1628V2.90698C0 2.10824 0.357034 1.36119 0.960211 0.823946C1.56081 0.289041 2.36007 0 3.1786 0H13.1005C13.919 0 14.7183 0.289041 15.3189 0.823946C15.922 1.36119 16.2791 2.10824 16.2791 2.90698V8.13953C16.2791 8.52485 15.9667 8.83721 15.5814 8.83721C15.1961 8.83721 14.8837 8.52485 14.8837 8.13953Z"
              fill={color}
            />
            <path
              d="M10.6195 4.65137C11.0048 4.65137 11.3171 4.96373 11.3171 5.34904C11.3171 5.73436 11.0048 6.04672 10.6195 6.04672H4.10783C3.72252 6.04672 3.41016 5.73436 3.41016 5.34904C3.41016 4.96373 3.72252 4.65137 4.10783 4.65137H10.6195Z"
              fill={color}
            />
            <path
              d="M6.89853 8.37207C7.28384 8.37207 7.5962 8.68443 7.5962 9.06974C7.5962 9.45506 7.28384 9.76742 6.89853 9.76742H4.10783C3.72252 9.76742 3.41016 9.45506 3.41016 9.06974C3.41016 8.68443 3.72252 8.37207 4.10783 8.37207H6.89853Z"
              fill={color}
            />
            <path
              d="M13.2555 15.1165C13.2555 14.9314 13.182 14.754 13.0511 14.6232C12.9203 14.4923 12.7429 14.4188 12.5579 14.4188C12.3728 14.4188 12.1954 14.4923 12.0646 14.6232C11.9337 14.754 11.8602 14.9314 11.8602 15.1165C11.8602 15.3015 11.9337 15.4789 12.0646 15.6097C12.1954 15.7406 12.3728 15.8141 12.5579 15.8141C12.7429 15.8141 12.9203 15.7406 13.0511 15.6097C13.182 15.4789 13.2555 15.3015 13.2555 15.1165ZM14.6509 15.1165C14.6509 15.6716 14.4302 16.2038 14.0377 16.5963C13.6452 16.9888 13.113 17.2095 12.5579 17.2095C12.0028 17.2095 11.4706 16.9888 11.078 16.5963C10.6855 16.2038 10.4648 15.6716 10.4648 15.1165C10.4648 14.5614 10.6855 14.0291 11.078 13.6366C11.4706 13.2441 12.0028 13.0234 12.5579 13.0234C13.113 13.0234 13.6452 13.2441 14.0377 13.6366C14.4302 14.0291 14.6509 14.5614 14.6509 15.1165Z"
              fill={color}
            />
            <path
              d="M12.559 10.2324C15.3885 10.2324 17.6788 11.8274 19.4367 14.7573C19.5691 14.9781 19.5691 15.2542 19.4367 15.475C17.6788 18.4048 15.3885 19.9999 12.559 19.9999C9.72956 19.9999 7.43921 18.4048 5.68129 15.475C5.54894 15.2542 5.54894 14.9781 5.68129 14.7573C7.43921 11.8274 9.72956 10.2324 12.559 10.2324ZM12.559 11.6278C10.4672 11.6278 8.64792 12.7163 7.1039 15.1161C8.64792 17.516 10.4672 18.6045 12.559 18.6045C14.6508 18.6045 16.4693 17.5157 18.0132 15.1161C16.4693 12.7166 14.6508 11.6278 12.559 11.6278Z"
              fill={color}
            />
          </>
        );
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

DataLayer.displayName = "DataLayer";

export { DataLayer };
